/* Publish by EComposer at 2026-08-04 17:31:53*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-lmcuo8hwm3"]=  window.__ectimmers["ecom-lmcuo8hwm3"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-lmcuo8hwm3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lmcuo8hwm3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vevzzb5iyp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vevzzb5iyp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cgeavm65jxm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cgeavm65jxm', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-962l2teemya"]=  window.__ectimmers["ecom-962l2teemya"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-962l2teemya"]["zhcyp8q96"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const s=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",s)}catch(r){console.error("[EC Tracking] Error publishing analytics event:",r)}const o=e.getAttribute("href"),a=e.getAttribute("target");o&&o!=="#"&&o!=="javascript:void(0)"&&(a==="_blank"?window.open(o,"_blank"):setTimeout(function(){window.location.href=o},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-962l2teemya').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-962l2teemya', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vdlrsxp3jjo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vdlrsxp3jjo', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 function formatSessionTime(totalMinutes) {
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  let result = '';

  if (hours > 0) {
    result += `${hours}h`;
  }

  if (minutes > 0) {
    result += `${result ? ' ' : ''}${minutes}m`;
  }

  return result || '0 minutes';
}

console.log(formatSessionTime(271788));

async function getStats() {
  const response = await fetch(
    'https://musical-basbousa-75d63c.netlify.app/.netlify/functions/stats'
  );

  const data = await response.json();

  document.querySelector('.total_community-hours-save .ecom__heading').textContent =
    formatSessionTime(data.totalSessionMinutes);
}

getStats();
document.addEventListener("DOMContentLoaded", () => {
  const review = document.querySelector(".junip-product-review");
  const targetSection = document.querySelector(".noise_bottom_section");

  if (!review || !targetSection) return;

  const reviewSection = review.closest(".shopify-section");

  if (reviewSection) {
    targetSection.parentNode.insertBefore(reviewSection, targetSection);
  }
});

} catch(error){console.error(error);}